export default __webpack_public_path__ + "static/media/eth.e618baa8.svg";